
import React, { lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import { Spin } from "antd";
import AuthPages from "./AuthPages";
import ProtectedRoutes from "./ProtectedRoutes";
import PortfolioLayout from "./Components/Portfolio Management/portfolioLayout";
import RequireAuth from "./requireAuth";


const FilterManagement = lazy(() => import("./Components/Filter Management/filterManagementList"));
const PortfolioList = lazy(() => import("./Components/Portfolio Management/portfolioList"));
const Customers = lazy(() => import("./Components/Customers/customers"));
const CustomerDetails = lazy(() => import("./Components/Customers/customerDetails"));
const StockAnalyser = lazy(() => import("./Components/Stock Analyser/stockAnalyser"));
const Strategymanagement = lazy(() => import("./Components/Strategy Management/strategymanagement"));
const ModelPortfolioDetails = lazy(() => import("./Components/Portfolio Management/portfolioViewDetails"));
const ModelPortfolioHistory = lazy(()=>import ("./Components/Portfolio Management/modelPortfolioHistory"));
const CreateFilters = lazy(() => import("./Components/Filter Management/createFilters"));
// const FilterHistory = lazy(()=> import("./Components/Filter Management/filterHistory"))
const ModalPortfolio = lazy(() => import("./Components/Customers/modalPortfolio"));
const RequestManager = lazy(() => import("./Components/Request Manager/requestManager"));
const NewRequest = lazy(() => import("./Components/Request Manager/newRequest"));
const ComboAdhocRequest = lazy(() => import("./Components/Request Manager/comboadhocrequest"));
const DocumentManager = lazy(() => import("./Components/Document Manager/documentManager"));
const AttachDocs = lazy(() => import("./Components/Document Manager/attachDocs"));
const EtfsList = lazy(() => import("./Components/Etfs/EtfsList"));
const SectorList = lazy(() => import("./Components/Sector/SectorList"));
const SectorTechnical = lazy(() => import("./Components/Sector/SectorTechnical"));
const Failedorder = lazy(() => import("./Components/failedOrders/Failedorder"));
const BondAnalysis = lazy(() => import("./Components/Bond Analysis/BondAnalysis"));
const BondData = lazy(() => import("./Components/Bond Analysis/BondData"));
const BondsAnalyzer = lazy(() => import("./Components/Bonds/BondsAnalyzer"));
const RebalanceOrders = lazy(() => import("./Components/Rebalance/RebalanceOrder"));
const StockSymbol = lazy(() => import("./Components/Stock Symbol/StockSymbol"))
// const Report = lazy(() => import("./Components/Reports/Report"))
const StockSplit = lazy(() => import("./Components/Stock Splitting/StockSplit"));
const CorporateAction = lazy(() => import("./Components/CorporateAction/corporateAction"));
const Billing = lazy(() => import("./Components/Billing/billing"));
const Email = lazy (()=>import("./Components/Email/email"))
const EmailHistory = lazy (()=>import("./Components/Email/EmailHistory"))
const IpoStocks = lazy(()=>import("./Components/IpoStocks/ipoStock"))
const BuySell = lazy (()=>import("./Components/buysell/buySell"))
function App() {
  const PageLoader = () => (
    <div className="page-loader">
      <Spin size="large" tip="Loading the page details... please wait" />
    </div>
  );

  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<AuthPages />} />
     <Route element={<ProtectedRoutes />}>
      <Route
                     path="/customers"
                     element={<RequireAuth><PortfolioLayout main={<Customers />} /></RequireAuth>}
                   />
                   <Route
                     path="/customer-details"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                   <Route
                     path="/customer-details/:portfolio"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                   <Route
                     path="/customer-details/:transaction"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                   <Route
                     path="/customer-details/:riskprofile"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                    <Route
                     path="/customer-details/:aum"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                    <Route
                     path="/customer-details/:debit-sheet"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                   <Route
                     path="/stock-analyser"
                     element={<RequireAuth><PortfolioLayout main={<StockAnalyser />} /></RequireAuth>}
                   />
                   <Route
                     path="/etf-list"
                     element={<RequireAuth><PortfolioLayout main={<EtfsList />} /></RequireAuth>}
                   />
                   <Route
                     path="/portfolio-management"
                     element={<RequireAuth><PortfolioLayout main={<PortfolioList />} /></RequireAuth>}
                   />
                   <Route
                     path="/model-portfolio-details"
                     element={<RequireAuth><PortfolioLayout main={<ModelPortfolioDetails />} /></RequireAuth>}
                   />
                    <Route
                     path="/model-portfolio-history"
                     element={<RequireAuth><PortfolioLayout main={<ModelPortfolioHistory />} /></RequireAuth>}
                   />
                   <Route
                     path="/strategy-management"
                     element={<RequireAuth><PortfolioLayout main={<Strategymanagement />} /></RequireAuth>}
                   />
                   <Route
                     path="/filter-management"
                     element={<RequireAuth><PortfolioLayout main={<FilterManagement />} /></RequireAuth>}
                   />
                   <Route
                     path="/create-filter-management"
                     element={<RequireAuth><PortfolioLayout main={<CreateFilters />} /></RequireAuth>}
                   />
                   {/* <Route
                     path="/edited-filter-management-history"
                     element={<RequireAuth><PortfolioLayout main={<FilterHistory />} /></RequireAuth>}
                   /> */}
                   <Route
                     path="/modal-portfolio"
                     element={<RequireAuth><PortfolioLayout main={<CustomerDetails />} /></RequireAuth>}
                   />
                   <Route
                     path="/sector-management"
                     element={<RequireAuth><PortfolioLayout main={<SectorList />} /></RequireAuth>}
                   />
                    <Route
                     path="/sector-technical"
                     element={<RequireAuth><PortfolioLayout main={<SectorTechnical />} /></RequireAuth>}
                   />
                   <Route
                     path="/failed-orders"
                     element={<RequireAuth><PortfolioLayout main={<Failedorder />} /></RequireAuth>}
                   />
                   <Route
                     path="/request-manager"
                     element={<RequireAuth><PortfolioLayout main={<RequestManager />} /></RequireAuth>}
                   />
                   <Route
                     path="/request-manager/:initiate-transaction"
                     element={<RequireAuth><PortfolioLayout main={<RequestManager />} /></RequireAuth>}
                   />
                    <Route
                     path="/request-manager/:bulk-transaction"
                     element={<RequireAuth><PortfolioLayout main={<RequestManager />} /></RequireAuth>}
                   />
                   <Route
                     path="/request-manager/:combo-transaction"
                     element={<RequireAuth><PortfolioLayout main={<RequestManager />} /></RequireAuth>}
                   />
                   <Route
                     path="/document-manager"
                     element={<RequireAuth><PortfolioLayout main={<DocumentManager />} /></RequireAuth>}
                   />
                   {/* <Route
                     path="/bond-analysis"
                     element={<RequireAuth><PortfolioLayout main={<BondAnalysis />} /></RequireAuth>}
                   />
                   <Route
                     path="/bond-data"
                     element={<RequireAuth><PortfolioLayout main={<BondData />} /></RequireAuth>}
                   /> */}
                   <Route
                     path="/stock-symbol"
                     element={<RequireAuth><PortfolioLayout main={<StockSymbol />} /></RequireAuth>}
                   />
                   <Route
                     path="/symbol-category"
                     element={<RequireAuth><PortfolioLayout main={<BondsAnalyzer />} /></RequireAuth>}
                   />
         
                   <Route
                     path="/rebalance"
                     element={<RequireAuth><PortfolioLayout main={<RebalanceOrders />} /></RequireAuth>}
                   />
                   {/* <Route
                     path="/reports"
                     element={<RequireAuth><PortfolioLayout main={<Report />} /></RequireAuth>}
                   /> */}
                   <Route
                     path="/stock-split"
                     element={<RequireAuth><PortfolioLayout main={<StockSplit />} /></RequireAuth>}
                   />
                   <Route
                     path="/corporate-action"
                     element={<RequireAuth><PortfolioLayout main={<CorporateAction />} /></RequireAuth>}
                   />
                   <Route
                     path="/billing"
                     element={<RequireAuth><PortfolioLayout main={<Billing />} /></RequireAuth>}
                   />
                    <Route
                     path="/email"
                     element={<RequireAuth><PortfolioLayout main={<Email />} /></RequireAuth>}
                   />
                   <Route
                     path="/email-history"
                     element={<RequireAuth><PortfolioLayout main={<EmailHistory />} /></RequireAuth>}
                   />
                    <Route
                     path="/ipo-stock"
                     element={<RequireAuth><PortfolioLayout main={<IpoStocks />} /></RequireAuth>}
                   />
                     <Route
                     path="/bought-sold"
                     element={<RequireAuth><PortfolioLayout main={<BuySell />} /></RequireAuth>}
                   />
                   {/* <Route
                     path="/zeroda"
                     element={<RequireAuth><PortfolioLayout main={<Zeroda />} /></RequireAuth>}
                   /> */}
         
                   {/* <Route
                     path="/bond-analysis:bond-data"
                     element={<RequireAuth><PortfolioLayout main={<BondAnalysis />} /></RequireAuth>}
                   /> */}
                   <Route
                     path="/attach-doc"
                     element={<RequireAuth><PortfolioLayout main={<AttachDocs />} /></RequireAuth>}
                   />
            {/* <ProtectedRoutes /> */}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
